import React, {Component} from 'react';
import {observer} from 'mobx-react';
import './CoinDetails.css';
import API from './API';
import Price from './Price';
import Change from "./Change";
import CoinDetailTable from "./CoinDetailTable";
import ViewState from "./ViewState";
import LargeChart from "./LargeChart";
import {Desktop, MobileTablet} from "./Responsive";

@observer
class CoinDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {coin: {}};
        this.getCoin = this.getCoin.bind(this);
        this.renderSymbol = this.renderSymbol.bind(this);
        this.updatePageTitle = this.updatePageTitle.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentWillMount() {
        this.props.appState.viewState = ViewState.detail;
        this.getCoin();
        this.updatePageTitle();
    }

    updatePageTitle(price) {
        let coin = this.state.coin;

        if (!coin || !coin.name) {
            return;
        }

        let currency = this.props.appState.currency;
        let currencyPrefix = currency.prefix;
        let currencySuffix = currency.suffix;
        document.title = coin.name + ': ' + currencyPrefix  + price + currencySuffix + ' - CoinGrasp';
    }

    async getCoin() {
        let symbol = this.props.match.params.symbol;
        let appState = this.props.appState;
        if (appState.selectedSymbol !== symbol) {
            appState.selectedSymbol = symbol;
        }

        let coin = await API.getCoin(appState);
        this.setState({coin});
        return coin;
    }

    static renderWebsite(title, website) {
        if (website) {
            return (
                <div>
                    <div className="subtitle">{title}:</div>
                    <div className="website">
                        <a href={website} target="_BLANK" rel="noopener noreferrer">{website} <img
                            src="/images/external.svg"
                            alt="External link"/></a>
                    </div>
                </div>
            );
        }

        return null;
    }

    renderDescription(description) {
        if (!description) {
            return null;
        }

        // Handles new line to it's own <p>
        return (
            <div>
                {description.split('\n').map((item, key) => {
                    return <p key={key}>{item}</p>
                })}
            </div>
        );
    }

    handleKeyDown(e) {
        if (e.keyCode === 27) {
            this.props.history.push('/');
            e.preventDefault(); // Let's stop this event.
            e.stopPropagation(); // Really this time.
        }
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    renderSymbol() {
        let coinData = this.props.appState.selectedCoin;
        if (!coinData) {
            return null;
        }

        let name = coinData.name;
        let symbol = coinData.symbol || '';
        let price = coinData.price || '';
        let currencySymbol = this.props.appState.currency.prefix;
        let change = coinData.change;
        let website = coinData.website;
        let description = coinData.description;
        let twitter = coinData.twitter;
        let facebook = coinData.facebook;
        let reddit = coinData.reddit;

        let currencyValue = this.props.appState.currency.value || 1.0;
        let formattedPrice = Price.format(price * currencyValue);
        this.updatePageTitle(formattedPrice);

        return (
            <div className="cg-coin-details box-shadow" onKeyDown={ this.handleKeyDown }>
                <div className="row">
                    <div className="cg-coin-details-left col-md-7">
                        <h2>
                            <span className={'cg-icon cg-icon-' + symbol.toUpperCase()}/>
                            <span className="name">{name}</span>
                            <span className="divider"/>
                            <span className="symbol">{symbol.toUpperCase()}</span>
                        </h2>
                        <div className="price-content">
                            <span className="price">{currencySymbol}{formattedPrice}&nbsp;</span>
                            <Change change={change}/>
                        </div>

                        <div className="coin-description">
                            {this.renderDescription(description)}
                        </div>

                        <CoinDetailTable {...this.props} coinData={coinData}/>
                    </div>
                    <div className="cg-coin-details-right col-md-offset-1 col-md-4">
                        <h3 className="">More about {name}</h3>
                        <div className="websites">
                            {CoinDetails.renderWebsite('Website', website)}
                            {CoinDetails.renderWebsite('Twitter', twitter)}
                            {CoinDetails.renderWebsite('Facebook', facebook)}
                            {CoinDetails.renderWebsite('Reddit', reddit)}
                        </div>
                    </div>
                </div>
                <div className="bottom-container">
                    {/*
                     <div className="bottom-menu">
                     <span className="bottom-menu-item clickable">Charts</span>
                     </div>
                     */}

                    <Desktop>
                        <LargeChart isDesktop { ...this.props } />
                    </Desktop>
                    <MobileTablet>
                        <LargeChart isDesktop={false} { ...this.props } />
                    </MobileTablet>
                </div>
            </div>
        )
    }

    render() {
        let selectedCoin = this.props.appState.selectedCoin;
        if (selectedCoin) {
            return this.renderSymbol(selectedCoin);
        } else {
            return (
                <div onKeyDown={ this.handleKeyDown }>404: No symbol found</div>
            );
        }
    }
}

export default CoinDetails;



// WEBPACK FOOTER //
// ./src/CoinDetails.js